import type { ReactNode } from "react";
import { usePersistentValue } from "@sdeapps/react-core";
import InformationBox from "components/InformationBox";
import { ContactsMetiersList } from "components/Informations/ContactsMetiers/ContactsMetiersList";
import { withComponentErrorBoundary } from "utils/errorHandling";
import { Skeleton } from "@mui/material";
import { ContactsMetiersIcon } from "icons";
import type { UseContactsMetiersParams } from "hooks";
import { useContactsMetiers } from "hooks";
import InformationsRucBox from "./RelationUsagerClient/InformationsRucBox";
import { localStorageKeys } from "config/app-config";

interface ContactsMetiersProps {
  useContactsMetiersParams: UseContactsMetiersParams;
}

function InnerContactsMetiersInformationBox({
  useContactsMetiersParams,
}: Readonly<ContactsMetiersProps>): ReactNode {
  const [isNavMenuOpen, setIsNavMenuOpen] = usePersistentValue<boolean>(
    localStorageKeys.collapseContactsMetiers,
    true
  );
  const { contactsMetiers, isLoading } = useContactsMetiers(useContactsMetiersParams);

  return (
    <InformationBox
      collapsible
      isOpen={isNavMenuOpen ?? true}
      setIsOpen={setIsNavMenuOpen}
      noChildrenPadding
      icon={ContactsMetiersIcon}
      articleTitle="Contacts Métiers">
      {isLoading ? (
        <Skeleton sx={{ height: "73px", width: "100%", marginY: "-15px" }} />
      ) : (
        <ContactsMetiersList contactsMetiers={contactsMetiers} />
      )}
      {useContactsMetiersParams.$type === "commune" && (
        <InformationsRucBox communeId={useContactsMetiersParams.collectiviteId} />
      )}
    </InformationBox>
  );
}

export const ContactsMetiersInformationBox = withComponentErrorBoundary(
  InnerContactsMetiersInformationBox
);
